export default class UpdateProfileRequest {
    constructor(email = '', firstName = '', lastName = '') {
        this.email = email,
            this.firstName = firstName,
            this.lastName = lastName
    }
}
